import React from 'react';
import PropTypes from 'prop-types';

export const ConversionHelpContext = React.createContext({});

export const ConversionHelpProvider = (props) => {
  const { helpIds, children } = props;

  return (
    <ConversionHelpContext.Provider value={helpIds}>
      {children}
    </ConversionHelpContext.Provider >
  );
};

ConversionHelpProvider.propTypes = {
  helpIds: PropTypes.shape({
    metricsOverall: PropTypes.string.isRequired,
    metricsVisits: PropTypes.string.isRequired,
    metricsVisitRate: PropTypes.string.isRequired,
    metricsAssists: PropTypes.string.isRequired,
    metricsTopPageVisits: PropTypes.string.isRequired,
    metricsAvgTime: PropTypes.string.isRequired,
    metricsAvgPages: PropTypes.string.isRequired,
    metricsTotalVisits: PropTypes.string.isRequired,
    metricsTotalConversions: PropTypes.string.isRequired,
    metricsConversionRate: PropTypes.string.isRequired,
    metricsTotalRevenue: PropTypes.string.isRequired,
    metricsEstRevenue: PropTypes.string,
    specialPagesTotalConversions: PropTypes.string.isRequired,
    tile: PropTypes.shape({
      Container: PropTypes.string.isRequired,
      UET: PropTypes.string.isRequired,
    }).isRequired,
    emailTag: PropTypes.shape({
      Container: PropTypes.string.isRequired,
      UET: PropTypes.string.isRequired,
    }).isRequired,
    emailPlatform: PropTypes.shape({
      Container: PropTypes.shape({
        WordPress: PropTypes.string.isRequired,
        Wix: PropTypes.string.isRequired,
        Shopify: PropTypes.string.isRequired,
        BigCommerce: PropTypes.string.isRequired,
      }).isRequired,
      UET: PropTypes.shape({
        WordPress: PropTypes.string.isRequired,
        Wix: PropTypes.string.isRequired,
        Shopify: PropTypes.string.isRequired,
        BigCommerce: PropTypes.string.isRequired,
      }).isRequired,
    }),
    allPlatformsLearnMore: PropTypes.string,
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
